<template>
    <div >
        <el-carousel :interval="5000" indicator-position="none" :height="screenheight">
            <el-carousel-item v-for="(item, index) in img_arr" :key="index">
                <img :src="item.format_img" style="width: 100%; height: 100%;" alt="" @click="openweb(item.image_url)">
            </el-carousel-item>
        </el-carousel>
        <div style="width: 1200px; margin: 100px auto;">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for="(item, index) in category_arr" :key="index" :label="item.name" :name="item.id"></el-tab-pane>
            </el-tabs>

            <div style="min-height: 500px;">
                <div v-if="data_list.length > 0">
                    <div v-for="(item, index) in data_list" :key="index" class="flx mt40 shouxing" @click="toArticleinfo(item.article_id)">
                        <div style="width: 200px; height: 120px;">
                            <img style="width: 200px; height: 120px;" :src="item.format_img" alt="">
                        </div>
                        <div class="ml30" style="width: 960px;">
                            <div class="flx aic jcsb cl5">
                                <span class="fs16 dffaaa">{{item.article_title}}</span>
                                <span class="fs15">{{item.article_year}} {{item.article_date}}</span>
                            </div>
                            <div class="mt30 fs15 dv2" style="color: #878787; line-height: 26px;" v-html="item.article_content"></div>
                        </div>
                    </div>
                </div>

                <el-empty description="暂无数据" v-if="data_list.length <= 0"></el-empty>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Index5',
    metaInfo: {
        title: '最新资讯  - 交农一品 | 上海上通优选农业科技发展有限公司',
        meta: [
            { keywords: '交农一品,上通优选,上海上通优选农业科技发展有限公司' },
            { description: '交农一品,隶属于上海上通优选农业科技发展有限公司,秉持三农情怀,为解决我国中小型农产品生产商在品牌运作、市场营销、持续发展方面的困境,特提供品牌赋能、技术支持、市场营销三大助力,为中国一流品质的农产品保驾护航,系为中小型优质农产品生产商提供品牌赋能、销售渠道服务的专业平台' }
        ]
    },   
    data () {
        return {
            screenheight: '500px',
            data_list: '',
            img_arr: '',
            category_arr: [
                {id: '0', name: '全部'},
                {id: '10', name: '行业资讯'},
                {id: '20', name: '交农动态'},
                {id: '30', name: '校友聚力'},
                {id: '40', name: '农友动态'},
            ],
            activeName: '0',
            screenWidth: null
        }
    },
    methods:{
        toArticleinfo(id) {
            this.$router.push({
                path: '/articledetails',
                query: {
                    id: id
                }
            })
        },
        getData() {
            this.$post('index.php?s=/api/index/article', {
                wxapp_id: 10001,
                category_type: this.activeName
            })
            .then((res) => {
                if(res.code == 1) {
                    var a_data = res.data.list;
                    for (let i = 0; i < a_data.length; i++) {
                        a_data[i].article_content = this.showHtml(a_data[i].article_content);
                        a_data[i].article_content = a_data[i].article_content.replace(/<\/?br[^>]*>/gi,'')
                    }
                    this.data_list = a_data;
                    this.img_arr = res.data.zxzx_lbtp;
                }
            }) 
        },
        getData2() {
            this.$post('index.php?s=/api/index/article', {
                wxapp_id: 10001,
                category_type: this.activeName
            })
            .then((res) => {
                if(res.code == 1) {
                    var a_data = res.data.list;
                    for (let i = 0; i < a_data.length; i++) {
                        a_data[i].article_content = this.showHtml(a_data[i].article_content);
                        a_data[i].article_content = a_data[i].article_content.replace(/<\/?br[^>]*>/gi,'')
                    }
                    this.data_list = a_data;
                }
            }) 
        },
        showHtml(str){
            return str
            .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g,"<")
            .replace(/&gt;/g,">")
            .replace(/&quot;/g,"\"")
            .replace(/&#39;/g, "\'")
            .replace(/<\/?p[^>]*>/gi,'')
            .replace(/<\/?hr[^>]*>/gi,'')
            .replace(/<\/?img[^>]*>/gi,'')
            .replace(/&amp;nbsp;/g,'\u3000')
        },
        handleClick(tab, event) {
            this.activeName = tab.name;
            this.getData2();
        },
        openweb(e) {
            if(e) {
                window.open(e)
            }
        },
    },
    watch: {
        screenWidth: {
            handler: function (val, oldVal) {
                if (val*500/1920 < 321.5) {
                    this.screenheight = '321.5px';
                } else {
                    this.screenheight = val*500/1920 + 'px';
                }
            },
        },
    },
    created() {
        var data = this.$route.query;
        if(data.id) {
            this.activeName = data.id;
        }
        this.getData();
    },
    mounted() {
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })()
        }
	},
}
</script>

<style scoped>
    .dffaaa{
        color: #333;
    }
    .dffaaa:hover{
        color: #C8161D;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/index5.vue